module.exports = __webpack_public_path__ + "img/ivTest_sub49.b5d8babc.jpg";